import {Footer} from './Footer';

export default {
    title: 'Navigation/Footer',
    component: Footer,
    tags: ['autodocs'],
    parameters: {
        layout: 'fullscreen',
    },
}

export const Default= {
    args: {
        "links": [
            {
                "type": "list",
                "settings": {
                    "link_list": "about"
                },
                "links_title": "About",
                "links": [
                    {
                        "title": "About Us",
                        "handle": "about-us",
                        "url": "/"
                    },
                    {
                        "title": "Locations",
                        "handle": "locations",
                        "url": "/"
                    },
                    {
                        "title": "Careers",
                        "handle": "careers",
                        "url": "/"
                    },
                    {
                        "title": "Design",
                        "handle": "design",
                        "url": "/"
                    },
                    {
                        "title": "Stores",
                        "handle": "stores",
                        "url": "/pages/stores"
                    }
                ],
                "product": null,
                "collection": null
            },
            {
                "type": "list",
                "settings": {
                    "link_list": "help"
                },
                "links_title": "Help",
                "links": [
                    {
                        "title": "Shipping",
                        "handle": "shipping",
                        "url": "/"
                    },
                    {
                        "title": "Returns",
                        "handle": "returns",
                        "url": "/"
                    },
                    {
                        "title": "Repairs",
                        "handle": "repairs",
                        "url": "/"
                    },
                    {
                        "title": "Track your order",
                        "handle": "track-your-order",
                        "url": "/pages/track-your-order"
                    },
                    {
                        "title": "Payments",
                        "handle": "payments",
                        "url": "/"
                    },
                    {
                        "title": "Contact Us",
                        "handle": "contact-us",
                        "url": "/"
                    }
                ],
                "product": null,
                "collection": null
            },
            {
                "type": "list",
                "settings": {
                    "link_list": "social"
                },
                "links_title": "Social",
                "links": [
                    {
                        "title": "Facebook",
                        "handle": "facebook",
                        "url": "/"
                    },
                    {
                        "title": "Instagram",
                        "handle": "instagram",
                        "url": "/"
                    },
                    {
                        "title": "X",
                        "handle": "x",
                        "url": "/"
                    }
                ],
                "product": null,
                "collection": null
            }
        ],
        "settings": {
            "container_type": "container",
            "company_icon": "//mindarc-integrations.myshopify.com/cdn/shop/files/logo.png?v=1707803960",
            "company_name": "Arctheme",
            "company_subtext": "Developed by MindArc",
            "color_schema": {
                "error": "json not allowed for this object"
            },
            "content_alignment": "left"
        }
    }
};
